<template>
  <div class="playlist__card card">
    <PlaylistCardImageGrid
      class="stick-all-corners"
      :images="images"
    >
      <div
        slot="empty"
        class="playlist__empty-indicator stylized"
      >
        <div class="cap-first">
          {{ $t('playlist.card.empty', { item: $t('playlist.label', { count: 0 }) }) }}
        </div>
      </div>

      <div
        slot="side"
        :to="`/playlists/${playlist.slug}`"
        class="
          playlist__side-overlay stylized
          text-center flex-column
          stick-top-left
        "
        :class="playlist.isPrivate ? 'is-private' : ''"
      >
        <div class="side-overlay__count">
          {{ playlist.videoCount }}
        </div>
        <div class="side-overlay__item">
          {{ $t('playlist.card.film', { count: playlist.videoCount }) }}
        </div>
        <i
          class="material-icons side-overlay__open-arrow"
          data-icon="chevron_right"
        />
      </div>
    </PlaylistCardImageGrid>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model } from '@viddsee/server-api-client';
import PlaylistCardImageGrid from './PlaylistCardImageGrid.ts.vue';

export default Vue.extend({
  components: {
    PlaylistCardImageGrid,
  },
  props: {
    playlist: {
      type: Object as PropType<Model.Playlist.VideoCollectionInfo>,
      required: true,
    },
  },
  data() {
    return {
      images: this.playlist.coverImages || [this.playlist.photoMediumUrl],
    };
  },
});
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/exports/_component-entry';

// Variables
$_playlist_bg-color: #333333;
$_playlist_side-overlay_bg-color--default: #4D0821;
$_playlist_side-overlay_bg-color--private: #08414D;

.playlist__card {
  background-color: $_playlist_bg-color;
  padding: 0;
  padding-top: 38%;
  position: relative;
  overflow: hidden;

  > * {
    // Remove card default child padding
    padding: 0;
  }
}

.playlist__empty-indicator {
  color: rgba(white, 0.5);
  font-weight: $font-weight-light;
}

.playlist__side-overlay {
  color: white;
  background: rgba($_playlist_side-overlay_bg-color--default, 0.85);
}
.playlist__side-overlay.is-private {
  background: rgba($_playlist_side-overlay_bg-color--private, 0.85);
}

.playlist__side-overlay {
  .side-overlay__count {
    font-size: 2.8em;
    line-height: 100%;
  }
  .side-overlay__item {
    font-size: 1.2em;
    text-transform: uppercase;
  }
  .side-overlay__open-arrow {
    position: absolute;
    right: 0.05em;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.1s;
  }
}
.playlist__card:hover .playlist__side-overlay .side-overlay__open-arrow {
  transform: translateY(-50%) translateX(1px);
}
.playlist__card:active .playlist__side-overlay .side-overlay__open-arrow {
  transform: translateY(-50%) translateX(4px);
}

</style>
